module.exports = __webpack_public_path__ + "static/img/12034B_5_6_7_R_20200721_LC.2c4cbdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12034B_5_6_7_R_20200721_LC.png
// module id = Ifce
// module chunks = 0